<!-- Toolbar -->
<div class="toolbar" role="banner">
  <div (click)="escalationPage()">
    <img alt="CH Logo" src="./assets/img/logo.png" />
  </div>
  <!--<span>Welcome Common Header</span>-->
  <div class="spacer"></div>
  <nav class="nav nav-masthead justify-content-center" *ngIf="sharedService.hideHeaderData | async">

    <!--<a class="nav-link" [ngClass]="{'active' : isUnconfirmedOrderBtn}" href="javascript:;" (click)="search(25)" *ngIf="isUnconfirmedOrder">Orders</a>-->
    <a class="nav-link" [ngClass]="{'active' : isEscalationBtn}" href="javascript:;" (click)="search('escalation')" *ngIf="isEscalation">Orders</a>

    <a class="nav-link" [ngClass]="{'active' : isReimbursementBtn}" href="javascript:;" (click)="search('reimbursement')" *ngIf="isReimbursement && !isRecovery">Reimbursement</a>

    <a class="nav-link" *ngIf="!isRecovery" [ngClass]="{'active' : isRefundBtn}" href="javascript:;" (click)="search('refund')" >Refund</a>

    <a class="nav-link" [ngClass]="{'active' : isLeads}" href="javascript:;" (click)="search('lead')" >Leads</a>
<!--old -->
    <!--<a class="nav-link" [ngClass]="{'active' : isUnconfirmedOrderBtn}" href="javascript:;" (click)="search(25)" *ngIf="isUnconfirmedOrder">Un-Confirmed</a>-->
    <!--<a class="nav-link" [ngClass]="{'active' : isUploadReportBtn}" href="javascript:;" (click)="search(1001)" *ngIf="isUploadReport">Upload Report</a>
    <a class="nav-link" [ngClass]="{'active' : isTestingPendingBtn}" href="javascript:;" (click)="search(2)" *ngIf="isTestingPendingOrders">Confirmed</a>
    <a class="nav-link" [ngClass]="{'active' : isRejectedOrdersBtn}" href="javascript:;" (click)="search(9)" *ngIf="isRejectedOrders">Rejected</a>
    <a class="nav-link" [ngClass]="{'active' : isCancelledOrdersBtn}" href="javascript:;" (click)="search(8)" *ngIf="isCancelledOrders">Cancelled</a>
    <a class="nav-link" [ngClass]="{'active' : isExecuteByVendorBtn}" href="javascript:;" (click)="search(301)" *ngIf="isExecuteByVendor">Execute By Vendor</a>
    <a class="nav-link" [ngClass]="{'active' : isExecuteByVendorBtn}" href="javascript:;" (click)="search(301)" *ngIf="isCustomerChecked">Customer CheckedIn</a>
    <a class="nav-link" [ngClass]="{'active' : isCompletedOrdersBtn}" href="javascript:;" (click)="search(6)" *ngIf="isCompletedOrders">Completed</a>
    <a class="nav-link"   [ngClass]="{'active' : isAllOrdersBtn}"href="javascript:;" (click)="search(0)">All Orders</a>-->
<!--old end -->
   
    <!-- <a class="nav-link" href="javascript:;" (click)="search(26)" *ngIf="from == 'dc'">Tests Pending</a> -->
    <!-- <a class="nav-link" href="javascript:;" (click)="search(26)" *ngIf="from =='ard'">Prescription Uploaded</a> -->
    <!--<a class="nav-link" [ngClass]="{'active' : isPendingPrescriptionBtn}" href="javascript:;" (click)="search(1001)" *ngIf="isPendingPrescription">Prescription Pending</a>-->
    <!--<a class="nav-link" [ngClass]="{'active' : isExecuteByVendorBtn}" href="javascript:;" (click)="search(302)" *ngIf="isCustomerChecked">Prescription Uploaded</a>-->
    <!-- <a class="nav-link" [ngClass]="{'active' : isSlotConfirmedBtn}" href="javascript:;" (click)="search(26)" *ngIf="isSlotConfirmed">Slot Not Confirmed</a>
    <a class="nav-link" [ngClass]="{'active' : isPaymentConfirmedBtn}" href="javascript:;" (click)="search(505)" *ngIf="isPaymentConfirmed">Payment Not confirmed</a> -->



   


   <!-- <div *ngIf="isUnconfirmedRequired" class="div-width">
    <div class="col-12">
       <label>UnConfirmed</label> 
      <select id="inputState" (change)="searchByStatus($event.target.value)" class="form-control" placeholder="Un Confirmed">

        
        <option value="" disabled selected>Un Confirmed</option>
        <option *ngFor="let data of userConfirmedList" value={{data.value}}>{{data.name}}</option>
      </select>
    </div>
  </div>  -->

  
    <!-- drop down end -->
    <!-- <a class="nav-link active" href="javascript:;" (click)="search(0)">All Orders</a> -->
   
  </nav>

  <!--  <div class="spacer"></div> -->

  <!-- <div class="col text-right">
    <div ngbDropdown class="d-inline-block">
      <button class="dropdown-toggle btn profile_btn" id="profile" ngbDropdownToggle><span class="user_pic"></span>Vivek
        Kaser</button>
      <div ngbDropdownMenu aria-labelledby="profile" class="dropdown-menu">
        <button ngbDropdownItem>Action - 1</button>
        <button ngbDropdownItem>Another Action</button>
        <button ngbDropdownItem>Something else is here</button>
      </div>
    </div>
  </div>
   -->
  <div class="col text-right login_btn">
    <select id="timeDropDown"  class="form-control col-form-label-sm" (change)="logout($event.target.value)">
   
      <!-- <option value="" >{{loggedInUserName}}</option>
      <option value="logout">Logout</option> -->
      <option *ngFor="let loginUserInfo of loginUserInfoList" [ngValue]="loginUserInfo.id">{{loginUserInfo.name}}</option>
  </select>

  </div>


<!-- drop down creation -->
  <!-- <div class="col text-right">
    <div ngbDropdown class="d-inline-block">
      <select formControlName="website" class="form-control" >
        
        
        <option *ngFor="let userInfo of userDataList">{{userInfo}}</option>
      </select>
    </div>
  </div> -->
<!-- drop down creation completed -->

</div>